;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import get from "lodash/get"
import map from "lodash/map"
import filter from "lodash/filter"
import keys from "lodash/keys"
import {
  PROFILE_BASICS,
  PROFILE_BASICS_CREDENTIAL_ABBREVIATIONS,
  PROFILE_ROLES_PRIMARY_ROLE,
  PROFILE_ROLES,
  PROFILE_ROLES_CREDENTIAL_ROLES_KEY,
  PROFILE_ROLES_COACHING_KEY,
  PROFILE_ROLES_COACHING_ROLES_KEY,
  PROFILE_ROLES_COACHING_OTHER_ROLE_KEY,
  PROFILE_ROLES_EDUCATOR_KEY,
  PROFILE_ROLES_EDUCATOR_ROLES_KEY,
  PROFILE_ROLES_EDUCATOR_OTHER_ROLE_KEY,
  PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_KEY,
  PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_ROLES_KEY,
  PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_OTHER_ROLES_KEY,
} from "../constants"
import { getRoleDisplay } from "./credentialUtils"
export const getPrimaryRole = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_ROLES}][${PROFILE_ROLES_PRIMARY_ROLE}]`,
    null,
  )
}
export const getCoachingRoles = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_ROLES}][${PROFILE_ROLES_COACHING_KEY}][${PROFILE_ROLES_COACHING_ROLES_KEY}]`,
    [],
  )
}
export const getCoachingOtherRole = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_ROLES}][${PROFILE_ROLES_COACHING_KEY}][${PROFILE_ROLES_COACHING_OTHER_ROLE_KEY}]`,
    null,
  )
}
export const getEducatorRoles = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_ROLES}][${PROFILE_ROLES_EDUCATOR_KEY}][${PROFILE_ROLES_EDUCATOR_ROLES_KEY}]`,
    [],
  )
}
export const getEducatorOtherRole = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_ROLES}][${PROFILE_ROLES_EDUCATOR_KEY}][${PROFILE_ROLES_EDUCATOR_OTHER_ROLE_KEY}]`,
    null,
  )
}
export const getAltHolisticRoles = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_ROLES}][${PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_KEY}][${PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_ROLES_KEY}]`,
    [],
  )
}
export const getAltHolisticOtherRoles = ({ provider }) => {
  return get(
    provider,
    `profileContent[${PROFILE_ROLES}][${PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_KEY}][${PROFILE_ROLES_ALTERNATIVE_OR_HOLISTIC_OTHER_ROLES_KEY}]`,
    [],
  )
}

export const getRolesString = ({ provider }) => {
  const credentialRoles = get(
    provider,
    `profileContent[${PROFILE_ROLES}][${PROFILE_ROLES_CREDENTIAL_ROLES_KEY}]`,
    [],
  )
  // console.log("getRolesString credentialRoles", credentialRoles)
  const coachingRoles = getCoachingRoles({ provider })
  const coachingOtherRole = getCoachingOtherRole({ provider })
  const educatorRoles = getEducatorRoles({ provider })
  const educatorOtherRole = getEducatorOtherRole({ provider })
  const altHolisticRoles = getAltHolisticRoles({ provider })
  const altHolisticOtherRoles = getAltHolisticOtherRoles({ provider })

  const allStandardRoles = []
    .concat(
      map(
        filter(credentialRoles, (role) => {
          return role.displayOnProfile
        }),
        (role) => {
          return getRoleDisplay(role.text)
        },
      ),
    )
    .concat(map(coachingRoles, (role) => `${role} Coach`))
    .concat(map(educatorRoles, (role) => `${role} Educator`))
    .concat(map(altHolisticRoles, ({ role }) => `${role} Provider`))

  let rolesString = allStandardRoles.join(", ")

  if (coachingOtherRole) {
    if (rolesString != "") {
      rolesString = `${rolesString}, ${coachingOtherRole} Coach`
    } else {
      rolesString = `${coachingOtherRole} Coach`
    }
  }

  if (educatorOtherRole) {
    if (rolesString != "") {
      rolesString = `${rolesString}, ${educatorOtherRole} Educator`
    } else {
      rolesString = `${educatorOtherRole} Educator`
    }
  }

  map(keys(altHolisticOtherRoles), (key) => {
    if (altHolisticOtherRoles[key]) {
      if (rolesString != "") {
        rolesString = `${rolesString}, ${altHolisticOtherRoles[key]} Provider`
      } else {
        rolesString = `${altHolisticOtherRoles[key]} Provider`
      }
    }
  })

  return rolesString
}

export const getRolesArray = ({ provider }) => {
  const credentialRoles = get(
    provider,
    `profileContent[${PROFILE_ROLES}][${PROFILE_ROLES_CREDENTIAL_ROLES_KEY}]`,
    [],
  )

  const coachingRoles = getCoachingRoles({ provider })
  const coachingOtherRole = getCoachingOtherRole({ provider })
  const educatorRoles = getEducatorRoles({ provider })
  const educatorOtherRole = getEducatorOtherRole({ provider })
  const altHolisticRoles = getAltHolisticRoles({ provider })
  const altHolisticOtherRoles = getAltHolisticOtherRoles({ provider })

  const allRoles = []
    .concat(
      map(
        filter(credentialRoles, (role) => {
          return role.displayOnProfile
        }),
        (role) => {
          return role.text
        },
      ),
    )
    .concat(map(coachingRoles, (role) => `${role} Coach`))
    .concat(map(educatorRoles, (role) => `${role} Educator`))
    .concat(map(altHolisticRoles, ({ role }) => `${role} Provider`))

  // let rolesString = allStandardRoles.join(", ")

  if (coachingOtherRole) {
    allRoles.concat(`${coachingOtherRole} Coach`)
  }

  if (educatorOtherRole) {
    allRoles.concat(`${educatorOtherRole} Educator`)
  }

  map(keys(altHolisticOtherRoles), (key) => {
    if (altHolisticOtherRoles[key]) {
      allRoles.concat(`${altHolisticOtherRoles[key]} Provider`)
    }
  })

  return allRoles
}
